import type { Node as TiptapNode } from '@tiptap/pm/model';

import type { IContentResolver } from './../ricos-types';

export class TiptapContentResolver implements IContentResolver<TiptapNode[]> {
  // eslint-disable-next-line no-useless-constructor
  private constructor(
    readonly id: string,
    readonly resolve: IContentResolver<TiptapNode[]>['resolve']
  ) {}

  static create(
    id: string,
    resolve: IContentResolver<TiptapNode[]>['resolve']
  ): IContentResolver<TiptapNode[]> {
    return new TiptapContentResolver(id, resolve);
  }
}
